import { OfflineQueueItem } from './chores';

/**
 * Whether the server refused a pushed action outright, so pushing it again can only fail again:
 * the rules say no (a child's edit, say one queued just before they were marked a child, or an
 * edit to a household its author has since left). Firestore reports that as a FirebaseError with
 * the code 'permission-denied'; callable functions as 'functions/permission-denied'.
 */
export function isRefusedByServer(error: unknown): boolean {
  if (typeof error !== 'object' || error === null || !('code' in error)) return false;
  const { code } = error as { code: unknown };
  return code === 'permission-denied' || code === 'functions/permission-denied';
}

/** What a refused action's report says: that it wasn't allowed, and is gone, with the server's reason. */
export function refusedMessage(error: unknown): string {
  const reason = error instanceof Error && error.message ? error.message : 'the server refused it';
  return `Not allowed, so it was discarded: ${reason}`;
}

/** The one-line summary of a sync's failures, or null when there were none. */
export function describeSyncFailures(failed: OfflineQueueItem[]): string | null {
  const refused = failed.filter(item => item.refused).length;
  const other = failed.length - refused;
  const parts: string[] = [];
  if (other > 0) parts.push(`Failed to sync ${other} action(s)`);
  if (refused > 0) parts.push(`${refused} action(s) not allowed and discarded`);
  return parts.length > 0 ? parts.join('; ') : null;
}
